import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = "podiumscript.active_program_id";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-inject active program_id for list/create endpoints
const PROGRAM_SCOPED_PATHS = ["/episodes", "/production", "/gaveta"];

api.interceptors.request.use((config) => {
  const pid = localStorage.getItem(STORAGE_KEY);
  if (!pid) return config;

  const url = (config.url || "").split("?")[0];
  // Only root list/create endpoints (no trailing path segments)
  const isScoped = PROGRAM_SCOPED_PATHS.some(
    (p) => url === p || url === `${p}/`
  );
  if (!isScoped) return config;

  if (config.method === "get") {
    config.params = { ...(config.params || {}), program_id: pid };
  } else if (config.method === "post") {
    // Add program_id to body if not already present
    if (config.data && typeof config.data === "object" && !Array.isArray(config.data)) {
      if (!config.data.program_id) config.data = { ...config.data, program_id: pid };
    }
  }
  return config;
});

export default api;
